import * as yup from 'yup'

const schema = yup.object().shape({
  currentPassword: yup.string().required().min(6),
  newPassword: yup.string().required().min(8).strongPassword(),
  confirmPassword: yup
    .string()
    .required()
    .min(8)
    .equalsSibling('newPassword', 'Senhas não coincidem.'),
})

export default schema
